import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function HourglassIcon({ className, width = 23, height = 23 }: IconProps) {
    return (
        <svg
            className={cn('fill-current', className)}
            width={width}
            height={height}
            xmlns='http://www.w3.org/2000/svg'
            id='Layer_1'
            data-name='Layer 1'
            viewBox='0 0 24 24'
        >
            <path d='m16.551,12.096c2.522-2.257,4.003-4.759,4.405-7.449.169-1.131-.165-2.281-.917-3.154-.765-.887-1.874-1.396-3.043-1.396H7.005c-1.169,0-2.279.51-3.043,1.397-.753.875-1.087,2.026-.917,3.158.405,2.699,1.884,5.198,4.401,7.444-2.517,2.246-3.996,4.746-4.401,7.444-.17,1.132.165,2.284.917,3.158.765.888,1.874,1.397,3.043,1.397h9.99c1.169,0,2.278-.509,3.043-1.396.753-.874,1.087-2.023.918-3.155-.402-2.69-1.883-5.191-4.405-7.449Zm1.972,9.298c-.384.446-.941.702-1.528.702H7.005c-.587,0-1.144-.256-1.528-.703-.378-.439-.54-.992-.456-1.556.375-2.499,1.923-4.839,4.599-6.957.24-.189.379-.479.379-.784s-.14-.595-.379-.784c-2.676-2.118-4.224-4.458-4.599-6.957-.084-.564.077-1.117.456-1.556.384-.446.941-.702,1.528-.702h9.99c.587,0,1.144.255,1.528.702.377.438.539.99.455,1.553-.373,2.488-1.92,4.831-4.601,6.962-.238.19-.377.478-.377.783s.139.593.377.783c2.681,2.132,4.229,4.474,4.601,6.962.084.563-.078,1.115-.456,1.553Zm-1.916-15.922c.125-.309.088-.659-.098-.935-.186-.275-.497-.441-.829-.441h-7.363c-.333,0-.643.166-.829.442-.186.275-.223.625-.098.933.748,1.853,2.3,3.346,3.471,4.272l.519.411c.182.145.401.216.621.216s.441-.073.623-.218l.508-.405c1.173-.933,2.728-2.432,3.475-4.276Zm-4.608,2.621c-.631-.509-1.371-1.193-1.966-1.996h3.928c-.593.798-1.331,1.484-1.962,1.996Z' />
        </svg>
    );
}

export default HourglassIcon;

